const shouldSkipValue = (value: unknown) => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  return false;
};

const appendParam = (params: URLSearchParams, key: string, value: unknown) => {
  if (shouldSkipValue(value)) {
    return;
  }

  if (value instanceof Date) {
    params.append(key, value.toISOString());
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendParam(params, `${key}[${index}]`, item);
    });
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value as Record<string, unknown>).forEach(([childKey, childValue]) => {
      appendParam(params, `${key}.${childKey}`, childValue);
    });
    return;
  }

  params.append(key, String(value));
};

export const serializeApiParams = (params?: Record<string, unknown>) => {
  if (!params) {
    return '';
  }

  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    appendParam(searchParams, key, value);
  });

  return searchParams.toString();
};

export const compactApiParams = <T extends Record<string, unknown>>(params: T): Partial<T> => {
  const entries = Object.entries(params).filter(([, value]) => !shouldSkipValue(value));
  return Object.fromEntries(entries) as Partial<T>;
};
